export enum ReportType {
  CHART = 'chart',
  PDF_PAGE = 'pdf-page',
}
